<script setup lang="ts">
const { title, clickable, closeable, simple } = defineProps({
  title: {
    type: String,
    required: true
  },
  clickable: {
    type: Boolean,
    default: false
  },
  closeable: {
    type: Boolean,
    default: false
  },
  simple: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['close'])

function onClose() {
  emit('close')
}
</script>
<template>
  <span
    w-fit
    flex
    flex-wrap
    items-center
    rounded-1.5
    py-1.2
    align-middle
    text-sm
    text-theme-main
    :class="{
      'hover:bg-theme-light cursor-pointer': clickable,
      'px-2.5 bg-theme-light-80': !simple
    }">
    #{{ title }}
    <i
      v-if="closeable"
      @click="onClose"
      i-material-symbols:close
      ml-2
      inline-block
      cursor-pointer
      text-lg
      hover:text-theme-main />
  </span>
</template>
<style lang="scss" scoped></style>
